module.exports = __webpack_public_path__ + "static/img/logobg.9399c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logobg.png
// module id = jhrp
// module chunks = 1